module.exports = __webpack_public_path__ + "static/media/onderhoud.808fa203.jpg";